import React from 'react'

const ArrowCaretUpIcon = ({ width = '18', height = '18', fill="none",...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4884_29)">
        <path d="M8 7.21855L4.7 10.5186L3.75732 9.57589L8 5.33325L12.2427 9.57589L11.3 10.5186L8 7.21855Z" fill={fill}/>
      </g>
      <defs>
        <clipPath id="clip0_4884_29">
          <rect width="16" height="16" fill={fill}/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default ArrowCaretUpIcon
